import React, { useEffect, useState, useRef } from 'react';
import styled, { css } from 'styled-components';

import UserInteraction from '../../moderator/userInteraction';
import * as palette from '../../../../../../../components/General/Variables';

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-flow: column;
    justify-content: space-between;
    height: 100%;
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    padding: ${props => (props.padding ? props.padding : 0)};
    overflow-y: scroll;
    @media (max-height: 800px) and (orientation: landscape) {
        max-width: 400px;
    }
`;

const InteractionWrapper = styled.div`
    flex: 3;
    height: 100%;
    min-height: 0;
    width: 100%;
    @media only screen and (max-width: ${palette.MAX_TABLET}) {
        bottom: 115px;
    }
`;

const RightContent = props => {
    const [interactionWindowHeight, setInteractionWindowHeight] = useState(null);

    const wrapperRef = useRef();
    const handleResize = () => {
        const wrapperHeight =
            wrapperRef.current && wrapperRef.current.getBoundingClientRect().height;
        const interactionHeight = window.innerHeight - wrapperHeight;
        setInteractionWindowHeight(
            window.innerHeight < 900 ? interactionHeight : interactionHeight + 200,
        );
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <Wrapper innerRef={wrapperRef}>
            <InteractionWrapper
                interactionWindowHeight={interactionWindowHeight}
                interactionInitialHeight={!interactionWindowHeight && window.innerHeight}
            >
                <UserInteraction controls={true} nonVirtualQA />
            </InteractionWrapper>
        </Wrapper>
    );
};

RightContent.propTypes = {};

export default RightContent;
